import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PrimaryButton from '../../../shared/buttons/PrimaryButton';

export default function DocumentUploadItem({
  title,
  description = '',
  isRequired = false,
  onUpload,
  onRemove,
  uploadedFile = null,
}) {
  return (
    <div className="flex items-center justify-between min-h-[65px]">
      <div className="flex-1">
        <div className="font-medium">{title}</div>
        <div className="text-sm text-gray-600">{description}</div>
        {isRequired && (
          <div className="text-xs max-w-max rounded-md p-1.5 text-primary-blue bg-secondary-blue font-medium mt-2">
            Required
          </div>
        )}
      </div>
      <div className="w-1/4">
        {!!uploadedFile ? (
          <div className="flex gap-2 justify-between items-center text-xs border rounded-full py-1 px-4">
            <span className="truncate max-w-[120px]" title={uploadedFile.name}>
              {uploadedFile.name}
            </span>
            <FontAwesomeIcon
              icon="close"
              className="cursor-pointer hover:text-secondary-gray flex-shrink-0"
              onClick={onRemove}
            />
          </div>
        ) : (
          <PrimaryButton
            buttonText="Upload"
            ariaLabel="Upload"
            buttonColor="bg-primary-blue"
            hoverClass="hover:bg-primary-blue-hover"
            onClick={onUpload}
          />
        )}
      </div>
    </div>
  );
}
